
import { defineComponent, type PropType } from 'vue';
import { ITrailModel } from '@/types/routewebmodel';

export default defineComponent({
  name: 'TrailMenu',
  props: {
    trail: {
      type: Object as PropType<ITrailModel>,
      required: true,
    },
  },
  computed: {
    showDescription() {
      if (this.trail) {
        return !this.trail.gpsOnly;
      }
      return false;
    },
    showGps() {
      if (this.trail) {
        return this.trail.gps;
      }
      return false;
    },
    showMap() {
      if (this.trail.maps) {
        return this.trail.maps.length > 0;
      }
      return false;
    },
    showPrint() {
      return this.showDescription;
    },
    mapLabel() {
      if (this.trail?.maps?.length === 1) {
        return 'Kaart';
      }
      return 'Kaarten';
    },
  },
  methods: {
    onClick() {
      this.$emit('btn-click');
    },
  },
});
